import React from 'react';
import JsxParser from 'react-jsx-parser'
import { getWidgetComponents } from './WidgetLibrary';
import useShortcodes from '../utils/useShortcodes';

export const WidgetParser = ({ bindings, jsx, additionalWidgets }: Props) => {

    const { applyShortcodes } = useShortcodes();
    const rendered = applyShortcodes(jsx, additionalWidgets);

    var addedWidgets = {};
    if (additionalWidgets) {
        additionalWidgets.map(w => {
            addedWidgets[w.component.NAME] = w.component;
        });
    }

    const widgets = {
        ...addedWidgets,
        ...getWidgetComponents(),
    };

    return (
        <JsxParser
            bindings={bindings}
            components={widgets}
            jsx={rendered}
        />
    )
}

interface Props {
    bindings?: Object,
    jsx: string,
    additionalWidgets?: Array<any>,
}

export default WidgetParser;